export default __webpack_public_path__ + "static/media/npi_logo.6b5fe596.jpeg";